import { subDays, startOfWeek, endOfWeek, eachDayOfInterval, format } from "date-fns";
import { OrderDetails, TimeRange } from "../shared/types/dashboard";
import { filterOrdersByHour, filterOrdersByDay, sumSales } from "./helpers";

export const generateTimeSeriesData = (orders: OrderDetails[], timeRange: TimeRange, customStartDate: string, customEndDate: string) => {
  const today = new Date();
  const series: Array<{ date: string; sales: number; orders: number }> = [];

  try {
    if (["today", "yesterday"].includes(timeRange)) {
      const targetDate = timeRange === "yesterday" ? subDays(today, 1) : today;
      for (let hour = 0; hour < 24; hour++) {
        const hourOrders = filterOrdersByHour(orders, targetDate, hour);
        series.push({
          date: `${hour}:00`,
          sales: sumSales(hourOrders),
          orders: hourOrders.length,
        });
      }
    } else if (timeRange === "week") {
      const weekDays = eachDayOfInterval({
        start: startOfWeek(today),
        end: endOfWeek(today),
      });

      weekDays.forEach((day) => {
        const dayOrders = filterOrdersByDay(orders, day);
        series.push({
          date: format(day, "EEE"),
          sales: sumSales(dayOrders),
          orders: dayOrders.length,
        });
      });
    } else {
      // Default: last 7 days
      for (let i = 6; i >= 0; i--) {
        const day = subDays(today, i);
        const dayOrders = filterOrdersByDay(orders, day);
        series.push({
          date: format(day, "MMM dd"),
          sales: sumSales(dayOrders),
          orders: dayOrders.length,
        });
      }
    }
  } catch (error) {
    console.error("Error generating time series:", error);
  }

  return series;
};
